"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditUserPersonalDocumentUploadDTOSchema = exports.UserPersonalDocumentUploadDTOSchema = exports.UserPersonalDocumentDTO = exports.UserPersonalDocumentDTOSchema = exports.UserPersonalDocumentSchema = exports.UserPersonalDocumentBaseSchema = void 0;
var zod_1 = require("zod");
var const_1 = require("./const");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var User_1 = require("./User");
var dateUtils_1 = require("./lib/dateUtils");
exports.UserPersonalDocumentBaseSchema = zod_1.z.object({
    // Everything BUT yachtName MAY become a ref
    UploadUrl: zod_1.z.string(),
    // Name is saved in DB as ObjectId for easier connection to a names collection in future
    // if it will be needed. Currently uses const values.
    Name: zod_1.z.instanceof(ObjectId_1.ObjectId),
    Status: zod_1.z.string().default('Uploaded'),
    Expiry: zod_1.z.coerce.date().optional(),
    // Who's the document meant for
    UserId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    // Who's uploading it
    AuthorId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    Notes: zod_1.z.string().optional(),
    assignedAdminId: zod_1.z
        .union([zod_1.z.string(), zod_1.z.instanceof(ObjectId_1.ObjectId)])
        .nullable()
        .optional(),
    adminWorkflowStatus: zod_1.z.enum(const_1.AdminWorkflowStatusArray).default('Pending'),
    assignedAt: zod_1.z.coerce.date().nullable().optional(),
    lastAdminEditDate: zod_1.z.coerce.date().optional(),
    lastAdminEdit: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    lastSRBOfficerEditDate: zod_1.z.coerce.date().optional(),
    lastSRBOfficerEdit: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    reviewComments: zod_1.z.string().optional(),
});
exports.UserPersonalDocumentSchema = exports.UserPersonalDocumentBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.UserPersonalDocumentDTOSchema = exports.UserPersonalDocumentSchema.extend(__assign({ Name: (0, ObjectId_1.ObjectIdString)('Invalid Name id'), UserId: (0, ObjectId_1.ObjectIdString)('Invalid UserId'), AuthorId: (0, ObjectId_1.ObjectIdString)('Invalid UserId'), assignedAdminId: (0, ObjectId_1.ObjectIdString)('Invalid assigned admin id').nullable().optional(), lastAdminEdit: (0, ObjectId_1.ObjectIdString)('Invalid last admin edit id').optional(), lastSRBOfficerEdit: (0, ObjectId_1.ObjectIdString)('Invalid last SRB officer edit id').optional() }, CommonMongoModelFields_1.CommonModelDTOFields));
exports.UserPersonalDocumentDTO = {
    convertFromModel: function (model) {
        var _a, _b, _c, _d, _e;
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            Status: model.Status,
            Name: model.Name._id ? model.Name._id.toString() : model.Name.toString(),
            UploadUrl: model.UploadUrl,
            UserId: model.UserId.toString(),
            User: (0, ObjectId_1.isPopulated)(model.UserId) ? User_1.UserDTO.convertFromModel(model.UserId) : undefined,
            AuthorId: model.AuthorId.toString(),
            Author: (0, ObjectId_1.isPopulated)(model.AuthorId) ? User_1.UserDTO.convertFromModel(model.AuthorId) : undefined,
            Notes: model.Notes,
            Expiry: (0, dateUtils_1.dateToDateString)(model.Expiry),
            assignedAdminId: (_a = model.assignedAdminId) === null || _a === void 0 ? void 0 : _a.toString(),
            adminWorkflowStatus: (_b = model.adminWorkflowStatus) !== null && _b !== void 0 ? _b : 'Pending',
            assignedAt: (_c = model.assignedAt) !== null && _c !== void 0 ? _c : undefined,
            lastAdminEditDate: model.lastAdminEditDate,
            lastAdminEdit: (_d = model.lastAdminEdit) === null || _d === void 0 ? void 0 : _d.toString(),
            lastSRBOfficerEditDate: model.lastSRBOfficerEditDate,
            lastSRBOfficerEdit: (_e = model.lastSRBOfficerEdit) === null || _e === void 0 ? void 0 : _e.toString(),
            reviewComments: model.reviewComments,
        };
        return dto;
    },
    convertToEditDTO: function (dto) {
        if (!dto)
            return {};
        var _assignedAdminId = dto.assignedAdminId, _adminWorkflowStatus = dto.adminWorkflowStatus, _assignedAt = dto.assignedAt, _lastAdminEditDate = dto.lastAdminEditDate, _lastAdminEdit = dto.lastAdminEdit, _lastSRBOfficerEditDate = dto.lastSRBOfficerEditDate, _lastSRBOfficerEdit = dto.lastSRBOfficerEdit, _reviewComments = dto.reviewComments, _user = dto.User, _author = dto.Author, editFields = __rest(dto, ["assignedAdminId", "adminWorkflowStatus", "assignedAt", "lastAdminEditDate", "lastAdminEdit", "lastSRBOfficerEditDate", "lastSRBOfficerEdit", "reviewComments", "User", "Author"]);
        var editDto = __assign(__assign({}, editFields), { Expiry: !dto.Expiry ? undefined : dto.Expiry });
        return editDto;
    },
};
exports.UserPersonalDocumentUploadDTOSchema = exports.UserPersonalDocumentBaseSchema.omit({
    UserId: true,
    Status: true,
    AuthorId: true,
    assignedAdminId: true,
    adminWorkflowStatus: true,
    assignedAt: true,
    lastAdminEditDate: true,
    lastAdminEdit: true,
    lastSRBOfficerEditDate: true,
    lastSRBOfficerEdit: true,
    reviewComments: true,
}).extend({
    Name: zod_1.z.string(),
    UserId: zod_1.z.string(),
});
exports.EditUserPersonalDocumentUploadDTOSchema = exports.UserPersonalDocumentUploadDTOSchema.extend({
    _id: zod_1.z.string(),
    Status: zod_1.z.string(),
    Expiry: zod_1.z.string().optional(),
});
//# sourceMappingURL=UserPersonalDocument.js.map